import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';

//Api
import pgrss_api from '../../../api/pgrss_api';

//Components
import TextField from '../../../components/TextField/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial do transportador
function initialStateTransportador() {
    return {
        tbTransportadores_Id: 0,
        tbTransportadores_Id_Selected: null,
        fantasia: "",
        licencaAmbiental: ""
    }
}

export default function Coleta({ coleta, setColeta }) {
    //Estado de controle dos erros nos campos dos transportadores
    const [errors, setErrors] = useState({});

    //Campos obrigatorios para adição de um transportador no pgrss
    const camposTransportador = [
        objCampo({ name: "tbTransportadores_Id_Selected", required: true }),
        objCampo({ name: "licencaAmbiental", required: true }),
    ]

    //Estado que guarda os dados do transportador
    const [transportadorPgrss, setTransportadorPgrss] = useState(initialStateTransportador);

    //Estado de controle das opções de transportadores
    const [optionsTransportadores, setOptionsTransportadores] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Opções dos selects de frequencias 
    const optionsFrequencia = [
        { text: "Selecione", value: "" },
        { text: "Diariamente", value: "Diariamente" },
        { text: "Dias alternados", value: "Dias alternados" },
        { text: "Semanal", value: "Semanal" },
        { text: "Duas vezes por dia", value: "Duas vezes por dia" },
        { text: "Outros", value: "Outros" },
    ]

    // cabeçalhos da tabela de transportadores
    const headersTabelaTransportadores = [
        { value: "Nome", objectValue: "fantasia" },
        { value: "Licença ambiental", objectValue: "licencaAmbiental" },
    ]

    //OnCHange para os campos de coleta
    const onChangeColeta = (e) => {
        const { name, value } = e.target;
        setColeta({
            ...coleta,
            [name]: value
        })
    }

    //OnCHange para o campo de licenca
    const onChangeLicenca = (e) => {
        const { name, value } = e.target;
        setTransportadorPgrss({
            ...transportadorPgrss,
            [name]: value
        })
    }

    //OnChange para o campo de select de transportador
    const onChangeTransportador = (e, select) => {
        const { name } = select;
        setTransportadorPgrss({
            ...transportadorPgrss,
            [name]: e,
            [name.split("_Selected")[0]]: e ? e.value : 0,
            fantasia: e ? e.label : ""
        })
    }
    //Função que faz a adição do transportador a lista de transportadores do pgrss
    const adicionarTransportador = () => {
        const _errors = validarCampos(transportadorPgrss, camposTransportador);
        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }
        setColeta({
            ...coleta,
            transportadores: [...coleta.transportadores, { ...transportadorPgrss }]
        })
        setOptionsTransportadores([...optionsTransportadores.filter(f => f.value !== transportadorPgrss.tbTransportadores_Id)])
        setTransportadorPgrss(initialStateTransportador);
    }

    //Função que remove o transportador da lista de transportadores
    const removerTransportador = (rowData) => {
        if (!rowData.tbTransportadores_Id_Selected) {
            rowData.tbTransportadores_Id_Selected = { label: rowData.fantasia, value: rowData.tbTransportadores_Id }
        }
        const transportadores = [...coleta.transportadores];
        setOptionsTransportadores([...optionsTransportadores, { ...rowData.tbTransportadores_Id_Selected }])
        transportadores.splice(rowData.tableData.id, 1);
        setColeta({ ...coleta, transportadores: [...transportadores] });
    }

    //Ações da tabela de listagem
    const actions = [
        actionsTable.remover(removerTransportador)
    ];

    //Carrega as opções de transportadores do select de transportadores
    useEffect(() => {
        setLoading(true)
        pgrss_api.GetTransportadoresPgrss().then(response => {
            response.data = response.data.map(value => {
                return { label: value.fantasia, value: value.tbTransportadores_Id }
            })
            response.data = response.data.filter(value => coleta.transportadores.filter(tr => tr.tbTransportadores_Id == value.value).length === 0);
            setOptionsTransportadores(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }, []);

    return (
        <div>
            {loading && <Loading />}
            <h4>Frequência de Coleta dos Resíduos</h4>
            <Row>
                <Col md="12" lg="6">
                    <TextField label={"Grupo A (Frequência)"} type="select" options={optionsFrequencia} name="frequenciaGrupoA" value={coleta.frequenciaGrupoA} onChange={onChangeColeta} />
                </Col>
                <Col md="12" lg="6">
                    <TextField maxLength={"100"} label={"Grupo A (Horários)"} name="horarioGrupoA" value={coleta.horarioGrupoA} onChange={onChangeColeta} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="6">
                    <TextField label={"Grupo B (Frequência)"} type="select" options={optionsFrequencia} name="frequenciaGrupoB" value={coleta.frequenciaGrupoB} onChange={onChangeColeta} />
                </Col>
                <Col md="12" lg="6">
                    <TextField maxLength={"100"} label={"Grupo B (Horários)"} name="horarioGrupoB" value={coleta.horarioGrupoB} onChange={onChangeColeta} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="6">
                    <TextField label={"Grupo C (Frequência)"} type="select" options={optionsFrequencia} name="frequenciaGrupoC" value={coleta.frequenciaGrupoC} onChange={onChangeColeta} />
                </Col>
                <Col md="12" lg="6">
                    <TextField maxLength={"100"} label={"Grupo C (Horários)"} name="horarioGrupoC" value={coleta.horarioGrupoC} onChange={onChangeColeta} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="6">
                    <TextField label={"Grupo D (Frequência)"} type="select" options={optionsFrequencia} name="frequenciaGrupoD" value={coleta.frequenciaGrupoD} onChange={onChangeColeta} />
                </Col>
                <Col md="12" lg="6">
                    <TextField maxLength={"100"} label={"Grupo D (Horários)"} name="horarioGrupoD" value={coleta.horarioGrupoD} onChange={onChangeColeta} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="6">
                    <TextField label={"Grupo E (Frequência)"} type="select" options={optionsFrequencia} name="frequenciaGrupoE" value={coleta.frequenciaGrupoE} onChange={onChangeColeta} />
                </Col>
                <Col md="12" lg="6">
                    <TextField maxLength={"100"} label={"Grupo E (Horários)"} name="horarioGrupoE" value={coleta.horarioGrupoE} onChange={onChangeColeta} />
                </Col>
            </Row>
            <h4>Transportadores</h4>
            <Row className='d-flex align-items-center'>
                <Col md="12" lg="5">
                    <TextField invalid={!!errors.tbTransportadores_Id_Selected} label={"* Transportador"} type={"select"} searchable name="tbTransportadores_Id_Selected" value={transportadorPgrss.tbTransportadores_Id_Selected} onChange={onChangeTransportador} options={optionsTransportadores} />
                </Col>
                <Col md="12" lg="5">
                    <TextField maxLength={"30"} invalid={!!errors.licencaAmbiental} label={"* Licença ambiental"} name="licencaAmbiental" onChange={onChangeLicenca} value={transportadorPgrss.licencaAmbiental} />
                </Col>
                <Col md="12" lg="2" >
                    <Button className='mt-3' color='primary' onClick={adicionarTransportador}>+ Adicionar</Button>
                </Col>
            </Row>
            <TabelaListagem actions={actions} title='Lista de transportadores' headers={headersTabelaTransportadores} items={coleta.transportadores} options={{ print: false, search: true, pagination: true }} />
        </div>
    )
}